import styled, { css } from 'styled-components';

import { ButtonWithRef } from 'components/button';

export const Text = styled.p<{ isRed?: boolean; isBold?: boolean }>`
  ${({ theme, isRed, isBold }) => css`
    color: ${isRed ? theme.config.text.red : theme.config.text.primary};

    ${isBold &&
    css`
      font-weight: 600;
    `}
  `}
`;

export const AddRowButton = styled(ButtonWithRef)`
  margin-top: 8px;
  width: fit-content;
`;

export const PayoutAmountRow = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr minmax(170px, 220px);
  gap: 8px;
  min-height: 40px;
`;

export const PayoutItemLabel = styled(Text)`
  margin: 0;
  font-weight: 600;
`;

export const PayoutItemControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PayoutAmountInput = styled.input`
  width: 100%;
  min-width: 0;
  height: 34px;
  padding: 0 10px;
  border: 1px solid ${({ theme }) => theme.config.input.border.default};
  border-radius: 6px;
  background: ${({ theme }) => theme.config.input.bg.default};
  color: ${({ theme }) => theme.config.input.text};
  font: inherit;

  &:focus {
    border-color: ${({ theme }) => theme.config.input.border.active};
    outline: none;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    margin: 0;
    appearance: none;
  }
`;

export { SubRows, SubRow, SubAmount, SubActions } from './subrows';
